// @flow
/* global SENTRY_ENDPOINT */ // eslint-disable-line no-unused-vars

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Raven from 'raven-js';
import { BrowserRouter } from 'react-router-dom';
import store from './store';
import './index.css';
import Page from './Page';
import './util/polyfill';
import './fonts.scss';
import { APP_PATH } from './config';

declare var SENTRY_ENDPOINT: string;

if (typeof SENTRY_ENDPOINT !== 'undefined') {
  Raven.config(SENTRY_ENDPOINT).install(); /* eslint no-console:0 */
}

const rootElement = document.getElementById('root');

if (rootElement instanceof Element) {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter
        basename={`/${APP_PATH}`}
        onUpdate={() => window.Appcues && window.Appcues.page()}
      >
        <Page />
      </BrowserRouter>
    </Provider>,
    rootElement
  );
}



// WEBPACK FOOTER //
// ./src/index.jsx